<template>
	<div>
		<div>
			<div style="display: flex;justify-content: space-between">
				<div>
					<el-input placeholder="请输入手机号进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search" clearable size="medium"
						@clear="initEmps" style="width: 350px;margin-right: 10px" v-model="keyword"
						@keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
					<el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
						搜索
					</el-button>
				</div>
			<!-- 	<div>
					<el-button type="success" @click="exportData" icon="el-icon-download">
						导出数据
					</el-button>
				</div> -->
			</div>
		</div>
		<div style="margin-top: 10px">
			<el-table :data="emps" stripe border v-loading="loading" element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
				style="width: 100%">
				<!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
				<el-table-column prop="karhName" align="center" label="客户姓名" min-width="12%">
				</el-table-column>
				<el-table-column prop="karhPhone" align="center" label="客户手机号" min-width="13%">
				</el-table-column>
				<el-table-column prop="tenantName" align="center" label="辩证场所" min-width="10%">
				</el-table-column>
				<el-table-column prop="karhSex" align="center" label="性别" min-width="8%">
					<template slot-scope="scope">
						{{scope.row.karhSex == '1' ? '男' : '女'}}
					</template>
				</el-table-column>
				<el-table-column prop="karhHeight" align="center" label="身高" min-width="8%">
				</el-table-column>
				<el-table-column prop="karhWeight" align="center" label="体重(KG)" min-width="8%">
				</el-table-column>
				<el-table-column prop="karhAge" align="center" label="年龄" min-width="8%">
				</el-table-column>
<!-- 				<el-table-column prop="karhMaibo" align="center" label="脉搏" min-width="8%">
				</el-table-column> -->
				<el-table-column prop="kashAnswerTime" min-width="15%" align="center" label="问诊时间">
				</el-table-column>
				<el-table-column
				        min-width="10%"
						align="center"
				        label="操作">
				    <template slot-scope="scope">
				        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">详情</el-button>
				        </el-button>
				    </template>
				</el-table-column>
			</el-table>
			<div style="display: flex;justify-content: flex-end">
				<el-pagination background @current-change="currentChange" @size-change="sizeChange"
					layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total">
				</el-pagination>
			</div>
		</div>
		<el-dialog
		        :title="title"
		        :visible.sync="dialogVisible"
				v-loading="loading2"
				element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"
		        width="80%">
		    <div class="dialog-box">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="问诊结果" name="consultationEmp"></el-tab-pane>
					<el-tab-pane label="问诊答卷" name="consultationAnswer"></el-tab-pane>
					<el-tab-pane label="问诊输出" name="consultationResults" v-if="currentHr.roles[0].roleId == '1001'"></el-tab-pane>	
				</el-tabs>
				<div style="max-height: 50vh;overflow-y: scroll;">
					<div v-show="activeName == 'consultationAnswer'">
						<div v-for="(item,index) in answerSheetQues">
							<div>{{item.kqihName}}</div>
							<div class="options_warp">
								<div v-for="(option,index) in item.kytOptions" class="option_item">
									<div class="icon" :class="[option.koihIsChoose == '1' ? 'picked' : 'unpick']"></div>
									<div>{{option.koihOption}}</div>
								</div>
							</div>
						</div>
					</div>
					<!-- <div style="font-size: 26px;margin: 10px 0;font-weight: bold;">问诊结果值</div> -->
					<div class="" v-show="activeName == 'consultationResults'">
						<div class="res_warp">
							<div v-for="(resitem,index) in formulaRes" class="item_warp">
								<div class="tit">{{resitem.kafrCode}}:</div>
								<div class="txt">{{resitem.kafrVal}}</div>
							</div>
						</div>

						
						<div v-for="(resitem,index) in graphicList" class="graphic_item_warp">
							<div style="display: flex;align-items: center;justify-content: flex-start;">
								<div class="tit">{{resitem.kafrCode}}:</div>
								<div class="txt">{{resitem.kafrVal}}</div>
							</div>
						</div>
						
						<div v-for="(resitem,index) in formulaResLarg" class="graphic_item_warp">
							<div class="tit">{{resitem.kafrCode}}:</div>
							<div class="txt">{{resitem.kafrVal}}</div>
						</div>
						
						<div v-for="(resitem,index) in graphicListLarg" class="graphic_item_warp">
							<div class="tit">{{resitem.kafrCode}}:</div>
							<div class="txt">{{resitem.kafrVal}}</div>
						</div>
					</div>
					<div v-show="activeName == 'consultationEmp'">
						<div class="cont">
							<!-- <div v-for="(item,index) in barDataList">
								<div class="tea_warp">
									<div class="flex-start">
										<div class="hot_icon"></div>
										<div class="tit">{{item.barLabel}}</div>
									</div>
								</div>
								<div class="echarts_box" :id="item.code"></div>
							</div> -->
							<div class="tea_warp" v-for="(item,index) in ztjk" v-if="ztjk.length > 0">
								<div class="flex-start">
									<div class="hot_icon"></div>
									<div class="tit">{{item.key}}</div>
								</div>
								<div class="tea_pro_warp ztzt">
									<template v-if="item.value.split('；').length >= 2">
										<template v-for="(tfitem,index) in item.value.split('；')">
											<div v-if="!containsChinese(tfitem)" class="tea_num"
											:class="{
												'red': Math.round(extractFirstNumber(tfitem)) < 60, 
												'yellow': 60 <= Math.round(extractFirstNumber(tfitem)) < 80,
												'green': Math.round(extractFirstNumber(tfitem)) >= 80 
											}"
											>
												{{Math.round(extractFirstNumber(tfitem))}}
											</div>
											<template v-else-if="!isConvertNail(tfitem)">
												<label v-if="index != 0">、</label>
												<label class="tea_txt">{{tfitem}}</label>
											</template>
											<div class="tea_remark" :class="{'margt': tfitem.startsWith('【') }" v-else>
												{{tfitem.trim()}}
											</div>
										</template>
									</template>
									<template v-else>
										<div v-if="!containsChinese(item.value)" class="tea_num" 
											:class="{ 
												'red': Math.round(extractFirstNumber(item.value)) < 60, 
												'yellow': 60 <= Math.round(extractFirstNumber(item.value)) < 80,
												'green': Math.round(extractFirstNumber(item.value)) >= 80 
											}">
											{{Math.round(extractFirstNumber(item.value))}}
										</div>
										<label class="tea_txt" v-else-if="!isConvertNail(item.value)">{{item.value}}</label>
										<div class="tea_remark" v-else>
											{{item.value}}
										</div>
									</template>
								</div>
							</div>
							<div v-for="(item,index) in echarDataList">
								<div class="tea_warp">
									<div class="flex-start">
										<div class="hot_icon"></div>
										<div class="tit">{{item.barLabel}}</div>
									</div>
								</div>
								<div class="echarts_box" :id="item.code"></div>
							</div>
							<div v-if="modelId == '1790339070123618306' || modelId == '1783017393672990722' || modelId == '1783017205873029121'
							|| modelId == '1789280886030118913' 
							|| modelId == '1790339218757169154' || modelId == '1791649651564785666'
							|| modelId == '1790338979778310146' || modelId == '2' || modelId == '1'">
								<div class="tea_warp">
									<div class="flex-start">
										<div class="hot_icon"></div>
										<div class="tit">辨识结果</div>
									</div>
									<div class="tea_pro_warp">
										<label v-for="(item,index) in bzjgList" class="tea_txt">
											<label v-if="index != 0">、</label>
											{{item.kafrName}}
										</label>
									</div>
								</div>
							</div>
							<div v-else>
							</div>
							<!-- <div class="tea_warp">
								<div class="flex-start">
									<div class="hot_icon"></div>
									<div v-if="modelName.indexOf('茶饮') >= 0" class="tit">定制茶饮</div>
									<div v-else-if="modelName.indexOf('开方') >= 0" class="tit">中药方剂</div>
									<div v-else-if="modelName.indexOf('饮食') >= 0" class="tit">定制膳食</div>
									<div v-else class="tit">--</div>
								</div>
								<div class="tea_pro_warp">
									<label v-for="(item,index) in teaLists" class="tea_txt">
										{{item}}
									</label>
								</div>
							</div> -->
						
							<div class="tea_warp" v-for="(item,index) in tuijianList">
								<div class="flex-start">
									<div class="hot_icon"></div>
									<div class="tit">{{item.key}}</div>
								</div>
								<div class="tea_pro_warp">
									<div v-if="item.isMusic == '1'">
										<div v-if="item.value.split('；').length >= 2" >
											<div v-for="(tfitem,index) in item.value.split('；')" class="music_item">
												<label class="tea_txt">
													{{tfitem}}
												</label>
												<audio ref="audioRefs" :src="bashUrl + item.path.split('；')[index]" controls  @play="playAudio(index)"></audio>
											</div>
						
										</div>
										<div v-else class="music_item">
											<label class="tea_txt">
												{{item.value}}
											</label>
											<audio :src="bashUrl + item.path" controls></audio>
										</div>
						
									</div>
									<div v-else>
										<template v-if="item.value.split('；').length >= 2">
											<template v-for="(tfitem,index) in item.value.split('；')">
												<div v-if="!containsChinese(tfitem)" class="tea_num"
												:class="{
													'red': Math.round(extractFirstNumber(tfitem)) < 60, 
													'yellow': 60 <= Math.round(extractFirstNumber(tfitem)) < 80,
													'green': Math.round(extractFirstNumber(tfitem)) >= 80 
												}"
												>
													{{Math.round(extractFirstNumber(tfitem))}}
												</div>
												<template v-else-if="!isConvertNail(tfitem)">
													<label v-if="index != 0">、</label>
													<label class="tea_txt">{{tfitem}}</label>
												</template>
												<div class="tea_remark" :class="{'margt': tfitem.startsWith('【') }" v-else>
													{{tfitem.trim()}}
												</div>
											</template>
										</template>
										<template v-else>
											<div v-if="!containsChinese(item.value)" class="tea_num" 
												:class="{ 
													'red': Math.round(extractFirstNumber(item.value)) < 60, 
													'yellow': 60 <= Math.round(extractFirstNumber(item.value)) < 80,
													'green': Math.round(extractFirstNumber(item.value)) >= 80 
												}">
												{{Math.round(extractFirstNumber(item.value))}}
											</div>
											<label class="tea_txt" v-else-if="!isConvertNail(item.value)">{{item.value}}</label>
											<div class="tea_remark" v-else>
												{{item.value}}
											</div>
										</template>
									</div>
						
								</div>
							</div>
						</div>
						<div class="tea_warp" v-if="answerSheetAttachs.length > 0" exportNo="999">
							<div v-for="item in parseAttachList(answerSheetAttachs,'')"
								class="attach_image_warp">
								<img :src="showAttach(item)" />
							</div>
						</div>
					</div>
				</div>

		    </div>
		    <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关 闭</el-button>
			  </span>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';
	import {
		v4 as uuidv4
	} from 'uuid'
	import * as echarts from 'echarts';
	export default {
		name: "Tenants",
		data() {
			return {
				answerSheetAttachs: [],
				title: '',
				showAdvanceSearchView: false,
				allDeps: [],
				emps: [],
				loading: false,
				loading2: false,
				dialogVisible: false,
				total: 0,
				page: 1,
				keyword: '',
				fromTenant: '',
				size: 10,
				formulasEnableList: [],
				answerSheetQues:[],
				tenantList: [],
				formulaRes:[],
				graphicList:[],
				formulaResLarg:[],
				graphicListLarg:[],
				activeName: 'consultationEmp',
				
				bashUrl: 'https://wxjkcn.com/attach/',
				modelId:'',
				kytGraphicModels:[],
				barShow:false,
				pieShow:false,
				pieDataList:[],
				barDataList:[],
				echarDataList:[],
				barLabel:'',
				pieLabel:'',
				ztjk:[],
				tuijianList: [],
				teaOrderList: [],
				tuijianOrderList: [],
				teaLists: [],
				bzjgList: [],
				ec: {
					lazyLoad: true
				},
				pieChartDom: null,
				pinOption: {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						show:false,
						orient: 'horizontal',
						bottom: '0',
						left: 'center',
						itemGap: 20
					},
					series: [{
						name: '',
						type: 'pie',
						radius: ['20%', '60%'],
						avoidLabelOverlap: false,
						label: {
							show: true,
							position: 'outside',
							verticalAlign: 'middle',
							align: 'center',
							//formatter: '{b}: {c}'
							formatter: '{b}'
						},
						emphasis: {
							label: {
								show: false,
								fontSize: 20,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							normal: {
								show: true,
								length: 10, // 标签线从环形图边缘到文字的长度
								length2: 10  // 标签线从图形边缘到文字的长度
							}
						},
						data: []
					}]
				},
				option: {
					grid: {
						top: '10%',
						left: '10%',
						right: '10%',
						bottom: '10%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: [],
						axisLabel: {
							rotate: 45, // 文字旋转 45 度
							fontSize: 10
						}
					},
					yAxis: {
						type: 'value',
						max: 100
					},
					series: [{
						data: [],
						type: 'bar',
						barWidth: '30%',
						showBackground: true,
						label: {
							show: true,
							position: 'top'
						},
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)'
						}
					}]
				}
			}
		},
		computed:{
			...mapState([
			      'currentHr' // 将 `this.count` 映射为 `store.state.count`
			]),
		},
		mounted() {
			this.initEmps();
			this.initData();
		},
		methods: {
			parseAttachList(answerSheetAttachs, vals) {
				console.log("parseAttachList")
				var attachs = []
				for (var index in answerSheetAttachs) {
					attachs.push(answerSheetAttachs[index].kasaFilePath)
				}
				console.log("attachs", attachs)
				return attachs;
			},
			previewAttach(path){
				path = path.replaceAll('/home/tea/attach/','')
				return ['https://wxjkcn.com/attach/'+path]
			},
			showAttach(path){
				path = path.replaceAll('/home/tea/attach/','')
				return 'https://wxjkcn.com/attach/' + path
			},
			handleClick(tab, event){
				console.log(tab, event);
			},
			showEditEmpView(data) {
			    this.title = '问诊答题信息';
				this.formulaRes = [];
			    this.emp = data;
			    this.dialogVisible = true;
				this.queryQuestionInfo(data);
				this.queryQuestionAttach(data);
				this.getformulaRes(data);
				this.queryH5Res(data);
			},
			queryQuestionAttach(data){
				this.answerSheetAttachs = []
				let url = '/answersheet/basic/getAnswerSheetAttachList';
				var params = {};
				params.answerSheetId = data.karhAsId;
				this.getRequest(url,params).then(resp => {
				    if (resp.status == 200) {
						this.answerSheetAttachs = resp.obj
				    }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
				});
			},
			queryH5Res(data){
				var modelId = data.kashModelId;
				this.modelId = data.kashModelId
				if (modelId == '1790339070123618306' || modelId == '1783017393672990722' || modelId == '1783017205873029121' ||
					modelId == '1789280886030118913' || modelId == '1790339218757169154' || modelId == '1791649651564785666' ||
					modelId == '1790338979778310146' || modelId == '2' || modelId == '1') {
					this.getAnswerResInfoByIdForMP(data)
				} else {
					//this.getComputeAnswerRes();
				}
				this.getComputeAnswerRes3(data);
			},
			getAnswerResInfoByIdForMP(data) {
				this.getRequest('/answersheet/basic/getAnswerResInfoByIdForMP',{answerSheetId:data.karhAsId}).then(resp => {
					if (resp.status == 200) {
						this.bzjgList = resp.obj
					}
				})
			},
			getComputeAnswerRes3(data){
				this.getRequest('/answersheet/basic/getComputeAnswerRes',{answerSheetId:data.karhAsId,type: "3"}).then(resp => {
					if (resp.status == 200) {
						var initres = resp
						this.kytGraphicModels = initres.obj.kytGraphicModels
						var invisibleFormulas = initres.obj.invisibleFormulas
						if(invisibleFormulas.length > 0){
							this.showDetail = true
						}else{
							this.showDetail = false
						}
						var graphicList = initres.obj.graphicList
						var kytFormulas = initres.obj.kytFormulas
						this.barDataList = []
						this.pieDataList = []
						for (var index in graphicList) {
							var code = graphicList[index].code
							var keyLabel = graphicList[index].key
							var kfExecNo = graphicList[index].index
							var fliterArr = this.kytGraphicModels.flatMap(e => {
								if(e.kgmCode === code){
									return e
								}
							}).filter(value => value !== undefined);
							if(fliterArr.length > 0){
								if(fliterArr[0].kgmName.trim() == '柱状图'){
									this.barShow = true
									this.barLabel = keyLabel
									var dataArr = JSON.parse( graphicList[index].value )
									this.option.series[0].data = []
									this.option.xAxis.data = []
									var barXaxis = []
									var barData = []
									for(var index in dataArr){
										var barKey = dataArr[index].key
										var tempFormula = kytFormulas.flatMap(e => {
											if(e.kfName === barKey){
												return e
											}
										}).filter(value => value !== undefined);
										barXaxis.push(tempFormula[0].kfNameCn)
										var barVal = Math.round(dataArr[index].val)
										barData.push({
											value: barVal,
											itemStyle: {color: this.generateRandomColor(barVal)}
										})
									}
									this.option.series[0].data = barData
									this.option.xAxis.data = barXaxis
									var tempOption = JSON.parse(JSON.stringify(this.option))
									/* this.$nextTick(() => {
										var barChartDom = document.getElementById('bar');
										var myBarChart = echarts.init(barChartDom);
										this.option && myBarChart.setOption(this.option);
									}) */
									this.barDataList.push(
										{
											'barLabel':keyLabel,
											'option':tempOption,
											'code': code,
											'name': '柱状图',
											'kfExecNo': kfExecNo
										}
									)
								}else if(fliterArr[0].kgmName.trim() == '饼图'){
									this.pieShow = true
									this.pieLabel = keyLabel
									var pieData = []
									var dataArr = JSON.parse( graphicList[index].value )
									for(var index in dataArr){
										var pieKey = dataArr[index].key
										var tempFormula = kytFormulas.flatMap(e => {
											if(e.kfName === pieKey){
												return e
											}
										}).filter(value => value !== undefined);
										pieData.push({
											name: tempFormula[0].kfNameCn,
											value: Math.round(dataArr[index].val) 
										})
									}
									this.pinOption.series[0].data = pieData
									/* this.$nextTick(() => {
										var pieChartDom = document.getElementById('pie');
										var myChart = echarts.init(pieChartDom);
										this.pinOption && myChart.setOption(this.pinOption);
									}) */
									var tempOption = JSON.parse(JSON.stringify(this.pinOption))
									this.pieDataList.push(
										{
											'barLabel':keyLabel,
											'option':tempOption,
											'code': code,
											'name': '饼图',
											'kfExecNo': kfExecNo
										}
									)
								}
							}
						}
						console.log(this.barDataList)
						console.log(this.pieDataList)
						var tempDataList = [];
						tempDataList = tempDataList.concat(this.barDataList);
						tempDataList = tempDataList.concat(this.pieDataList);
						this.echarDataList = tempDataList.sort(function(a, b) {
							var aKfExecNo = parseInt(a.kfExecNo)
							var bKfExecNo = parseInt(b.kfExecNo)
							return aKfExecNo - bKfExecNo;
						});
						this.$nextTick(() => {
							for (var index in this.barDataList) {
								var pieChartDom = document.getElementById(this.barDataList[index].code);
								var myChart = echarts.init(pieChartDom);
								myChart.setOption(this.barDataList[index].option);
							}
							for (var index in this.pieDataList) {
								var pieChartDom = document.getElementById(this.pieDataList[index].code);
								var myChart = echarts.init(pieChartDom);
								myChart.setOption(this.pieDataList[index].option);
							}
						})
						this.tuijianList = initres.obj.tuijianList
						for (var index in this.tuijianList) {
							/* if(this.tuijianList[index].key == '定制足浴'){
								this.tuijianOrderList.push(this.tuijianList[index].value)
							}
							if(this.tuijianList[index].key == '定制汤饮'){
								this.tuijianOrderList.push(this.tuijianList[index].value)
							} */
							
							if (this.tuijianList[index].key == '定制贴敷') {
								var finalList = this.tuijianList[index].value.split('；');
								console.log(finalList)
								if (this.modelId == '1789280886030118913' ||
									this.modelId == '1790339218757169154' || this.modelId == '1790339070123618306' || this
									.modelId == '1791649651564785666') {
									if (finalList.length >= 3) {
										this.tuijianOrderList = this.tuijianOrderList.concat(finalList)
									} else {
										this.tuijianOrderList = this.tuijianOrderList.concat(finalList)
									}
								} else {
									this.tuijianOrderList = this.tuijianOrderList.concat(finalList)
								}
							} else {
								this.tuijianOrderList.push(this.tuijianList[index].value)
							}
						}
						console.log(this.tuijianOrderList)
						this.ztjk = this.tuijianList.filter(e => e.key === '整体健康状态')
						this.tuijianList = this.tuijianList.filter(e => e.key != '整体健康状态')
					}
				})
			},
			queryQuestionInfo(data){
				this.loading2 = true;
				this.answerSheetQues = [];
				let url = '/answersheet/basic/getAnswerSheetQues';
				var params = {};
				params.answerSheetId = data.karhAsId;
				this.getRequest(url,params).then(resp => {
			        this.loading2 = false;
			        if (resp.status == 200) {
						this.answerSheetQues = resp.obj
			        }else{
						this.$message({
						    type: 'info',
						    message: '查询信息有误'
						});
					}
			    });
			},
			exportData() {
				var params = {};
				params.cusFromTenantId = this.fromTenant
				let url = '/customer/basic/export';
				this.downLoadRequest(url, params).then(res => {
					const content = res
					const blob = new Blob([content])
					const fileName = '导出.xls'
					if ('download' in document.createElement('a')) { // 非IE下载
						const elink = document.createElement('a')
						elink.download = fileName
						elink.style.display = 'none'
						elink.href = URL.createObjectURL(blob)
						document.body.appendChild(elink)
						elink.click()
						URL.revokeObjectURL(elink.href) // 释放URL 对象
						document.body.removeChild(elink)
					} else { // IE10+下载
						navigator.msSaveBlob(blob, fileName)
					}
				});
			},
			initData() {
				this.getTenantsAllList()
			},
			getTenantsAllList() {
				let url = '/tenant/basic/getTenantsAllList';
				this.getRequest(url).then(resp => {
					if (resp.status == 200) {
						this.tenantList = resp.obj;
					} else {

					}
				});
			},
			getformulaRes(data){
				let url = '/answersheet/basic/getAnswerResInfoById?asid='+data.karhAsId;
				this.getRequest(url).then(resp => {
					if (resp.status == 200) {
						var res = resp.obj
						this.formulaResLarg = res.filter(e => e.kafrVal.indexOf('[{') < 0 && e.kafrVal.length > 6 );
						this.graphicListLarg = res.filter(e => e.kafrVal.indexOf('[{') >= 0 && e.kafrVal.length > 6);
						this.formulaRes = res.filter(e => e.kafrVal.indexOf('[{') < 0 && e.kafrVal.length <=6 );
						this.graphicList = res.filter(e => e.kafrVal.indexOf('[{') >= 0 && e.kafrVal.length <= 6);
					} else {
				
					}
				});
			},
			sizeChange(currentSize) {
				this.size = currentSize;
				this.initEmps();
			},
			currentChange(currentPage) {
				this.page = currentPage;
				this.initEmps('advanced');
			},
			initEmps(type) {
				this.loading = true;
				let url = '/answersheet/basic/getAllAnswerResList?page=' + this.page + '&size=' + this.size;
				url += "&telNum=" + this.keyword;
				url += "&cusFromTenantId=" + this.fromTenant;
				this.getRequest(url).then(resp => {
					this.loading = false;
					if (resp) {
						this.emps = resp.data;
						this.total = resp.total;
					}
				});
			},
			playAudio(index) {
				console.log(index)
			    // 获取所有 audio 元素的引用
			    const audioElements = this.$refs.audioRefs;
			    // 遍历所有 audio 元素
			    audioElements.forEach((audio, i) => {
			        if (i === index) {
						// 如果是当前点击的音频，则播放
						audio.play();
			        } else {
						// 否则，暂停该音频
						audio.pause();
			        }
				});
			},
			containsChinese(str) {
			    const reg = /[\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9f]/;
			    return reg.test(str);
			},
			isConvertNail(txt){
				if (txt.includes("说明】") || txt.includes("方法】") || /^\d+、/.test(txt)) {
					return true
				}else{
					return false
				}
			},
			extractFirstNumber(str) {
			    const match = str.match(/(\d+(\.\d+)?)/);
			    return match ? match[0] : 0;
			},
			generateRandomColor(val) {
				if (val > 80) {
					return '#fe0606'
				}else if(val >= 60 ){
					return '#f5c756'
				}else {
					return '#3eb417'
				}
			    //return '#' + Math.floor(Math.random() * 16777215).toString(16);
			},
		}
	}
</script>

<style scoped lang="scss">
	.attach_image_warp {
		width: 300px;
		img {
			width: 100%;
			height: auto;
		}
	}
	.echarts_box {
		height: 200px;
	}
	.res_warp {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;
		.item_warp:not(:last-child) {
			/* margin-right: 120px; */
		}
		.item_warp {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: auto;
			line-height: 34px;
			.tit {
				font-size: 16px;
				min-width: 110px;
				font-weight: 700;
			}
			.txt {
				font-size: 16px;
				width: 110px;
			}
		}
	}
	.graphic_item_warp {
		line-height: 34px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		.tit {
			font-size: 16px;
			font-weight: 700;
			margin-right: 10px;
		}
		.txt {
			font-size: 16px;
			flex: 1;
		}
	}
	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all .8s ease;
	}

	.slide-fade-leave-active {
		transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}

	.el-form-item {
		display: flex;

		.input_box {
			width: 28.5rem;

			.el-input {
				width: 100% !important;
			}

			.el-select {
				width: 100% !important;
			}
		}
	}

	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;

		.box_tit {
			font-size: 0.875rem;
		}
	}

	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}

	.options_warp {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		margin-top: 1.25rem;
		margin-bottom: 0.45rem;
		padding-left: 1.25rem;
		.option_item {
			margin-bottom: 0.625rem;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			.icon {
				width: 1.25rem;
				height: 1.25rem;
			}
			.picked {
				background: url('../../assets/pick.png') no-repeat center;
				background-size: 100%;
			}
			.unpick {
				background: url('../../assets/unpick.png') no-repeat center;
				background-size: 100%;
			}
		}
	}

	::v-deep .dialog-box {
		.el-form-item__label {
			width: 5.125rem;
		}
	}
	.flex-start {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.tea_warp {
		padding: 10px;
		margin-top: 15px;
	
		.hot_icon {
			background: url('../../assets/hot.png') no-repeat center;
			background-size: 100%;
			width: 25px;
			height: 25px;
		}
	
		.tit {
			margin-left: 8px;
			font-size: 17px;
			font-weight: 700;
		}
	}
	.tea_pro_warp {
		/* display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap; */
		margin-top: 20px;
		text-align: left;
	
		.pro_box {
			/* width: 33.33%;
			height: 140rpx;
			text-align: center;
			display: flex;
			align-items: center;
			justify-content: center; */
	
		}
	
		.tea_txt {
			color: blue;
			/* text-decoration: underline; */
			font-size: 16px;
			/* margin-right: 10px; */
			line-height: 32px;
		}
		
		.tea_remark {
			color: blue;
			line-height: 28px;
			margin-top: 16px;
		}
		
		.tea_num {
			font-size: 60px;
			text-align: center;
			font-weight: 700;
		}
		
		.margt {
			margin-top: 10px;
		}
	}
	.ztzt {
		position: relative;
		.tea_remark {
			
		}
		.tea_num {
			
		}
	}
	.red {
	  color: #fe0606;
	}
	.yellow {
	  color: #f5c756;
	}
	.green {
		color: #3eb417;
	}
	.detail_res {
		/* line-height: 40px;
		height: 40px; */
		padding-top: 20px;
		position: fixed;
		top: 0;
		right: 20px;
		z-index: 999;
		color: blue;
		/* text-decoration: underline; */
		font-size: 17px;
		font-weight: 700;
	}
	.music_item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 16px;
	}
</style>